import React from "react";

import Variedade from "entity/Variedade";

import DefaultEntityCrud from "components/form/DefaultEntityCrud";
import FormContent from "components/form/FormContent";
import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";

function VariedadeFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <TextInput sx={{ flex: 0.5 }} name="sequencialIndex" label="Código" disabled />
            <SelectInput sx={{ flex: 0.5 }} name="status" label="Status" options={["ATIVO", "INATIVO"]} required />
            <TextInput sx={{ flex: 2 }} name="variedade" label="Variedade" required />
        </FormContent>
    );
}

export default function VariedadeForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Variedade"}
            EntityClass={Variedade}
            routeForm={"_variedade"}
            backRoute="consulta-variedade"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <VariedadeFormInter {...props} />}
        </DefaultEntityCrud>
    );
}
